// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown-wrapper > .custom-dropdown button,
.custom-dropdown-wrapper > .custom-dropdown .p-button {
  height: 42px !important;
}

.withoutHeader.custom-overlay-panel-dropdown
  .p-datatable
  .p-datatable-tbody
  > tr
  > td,
.custom-overlay-panel-dropdown .p-datatable .p-datatable-thead > tr > th {
  border: none !important;
}

.custom-overlay-panel-dropdown .p-datatable .p-datatable-tbody > tr > td,
.custom-overlay-panel-dropdown .p-datatable .p-datatable-thead > tr > th {
  border-top: none !important;
  border-bottom: none !important;
}

.withoutHeader.custom-overlay-panel-dropdown
  [data-pc-section='headerrow']
  [role='columnheader'],
.custom-overlay-panel-dropdown .p-filter-column {
  display: none;
}

.custom-dropdown .p-dropdown-label {
  color: #6c757d;
  padding-left: 0.75rem;
  text-align: left;
  border-color: #6c757d4d;
  width: 100%;
  padding-right: 140px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.custom-dropdown .p-dropdown-label.withoutCreate {
  padding-right: 88px !important;
}

.priority-high.custom-dropdown .p-dropdown {
  border-color: maroon !important;
}

.priority-high.custom-dropdown .p-dropdown-label {
  color: maroon;
}

.custom-overlay-panel-dropdown .p-overlaypanel-content {
  padding: 0.5rem;
}

.custom-dropdown .custom-dropdown-action-buttons {
  position: absolute;
  right: 0;
}

.custom-overlay-panel-dropdown .p-datatable-thead > tr > th,
.custom-overlay-panel-dropdown .p-datatable-tbody > tr > td {
  border-right: 1px solid #ddd; /* Add a border to the right of each column */
}

.custom-overlay-panel-dropdown .p-datatable-thead > tr > th:last-child,
.custom-overlay-panel-dropdown .p-datatable-tbody > tr > td:last-child {
  border-right: none; /* Remove the border from the last column */
}

.custom-overlay-panel-dropdown .p-datatable-tbody > tr > td {
  padding: 0.75rem; /* Optional: Adjust the padding for better spacing */
}

.dropdown-tree-hr_fisrtItem .p-tree-container > .p-treenode:nth-child(1) {
  border-bottom: 1px solid rgb(201, 201, 201);
}

.custom-dropdown .clear-on-hover,
.custom-dropdown .create-on-hover {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.custom-dropdown .custom-dropdown:hover .clear-on-hover,
.custom-dropdown .custom-dropdown:hover .create-on-hover {
  opacity: 1;
}


.invalid .p-dropdown-label {

  border: solid 1px #e98181b8 !important;
  border-radius: 3px;
} 

.valid .p-dropdown-label { 
  border: solid 1px #00800073 !important;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/ui/custom-controls/styles/CustomDropdown.css"],"names":[],"mappings":"AAAA;;EAEE,uBAAuB;AACzB;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,4BAA4B,EAAE,6CAA6C;AAC7E;;AAEA;;EAEE,kBAAkB,EAAE,2CAA2C;AACjE;;AAEA;EACE,gBAAgB,EAAE,oDAAoD;AACxE;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,UAAU;EACV,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;AACZ;;;AAGA;;EAEE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB","sourcesContent":[".custom-dropdown-wrapper > .custom-dropdown button,\n.custom-dropdown-wrapper > .custom-dropdown .p-button {\n  height: 42px !important;\n}\n\n.withoutHeader.custom-overlay-panel-dropdown\n  .p-datatable\n  .p-datatable-tbody\n  > tr\n  > td,\n.custom-overlay-panel-dropdown .p-datatable .p-datatable-thead > tr > th {\n  border: none !important;\n}\n\n.custom-overlay-panel-dropdown .p-datatable .p-datatable-tbody > tr > td,\n.custom-overlay-panel-dropdown .p-datatable .p-datatable-thead > tr > th {\n  border-top: none !important;\n  border-bottom: none !important;\n}\n\n.withoutHeader.custom-overlay-panel-dropdown\n  [data-pc-section='headerrow']\n  [role='columnheader'],\n.custom-overlay-panel-dropdown .p-filter-column {\n  display: none;\n}\n\n.custom-dropdown .p-dropdown-label {\n  color: #6c757d;\n  padding-left: 0.75rem;\n  text-align: left;\n  border-color: #6c757d4d;\n  width: 100%;\n  padding-right: 140px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.custom-dropdown .p-dropdown-label.withoutCreate {\n  padding-right: 88px !important;\n}\n\n.priority-high.custom-dropdown .p-dropdown {\n  border-color: maroon !important;\n}\n\n.priority-high.custom-dropdown .p-dropdown-label {\n  color: maroon;\n}\n\n.custom-overlay-panel-dropdown .p-overlaypanel-content {\n  padding: 0.5rem;\n}\n\n.custom-dropdown .custom-dropdown-action-buttons {\n  position: absolute;\n  right: 0;\n}\n\n.custom-overlay-panel-dropdown .p-datatable-thead > tr > th,\n.custom-overlay-panel-dropdown .p-datatable-tbody > tr > td {\n  border-right: 1px solid #ddd; /* Add a border to the right of each column */\n}\n\n.custom-overlay-panel-dropdown .p-datatable-thead > tr > th:last-child,\n.custom-overlay-panel-dropdown .p-datatable-tbody > tr > td:last-child {\n  border-right: none; /* Remove the border from the last column */\n}\n\n.custom-overlay-panel-dropdown .p-datatable-tbody > tr > td {\n  padding: 0.75rem; /* Optional: Adjust the padding for better spacing */\n}\n\n.dropdown-tree-hr_fisrtItem .p-tree-container > .p-treenode:nth-child(1) {\n  border-bottom: 1px solid rgb(201, 201, 201);\n}\n\n.custom-dropdown .clear-on-hover,\n.custom-dropdown .create-on-hover {\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.custom-dropdown .custom-dropdown:hover .clear-on-hover,\n.custom-dropdown .custom-dropdown:hover .create-on-hover {\n  opacity: 1;\n}\n\n\n.invalid .p-dropdown-label {\n\n  border: solid 1px #e98181b8 !important;\n  border-radius: 3px;\n} \n\n.valid .p-dropdown-label { \n  border: solid 1px #00800073 !important;\n  border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
